const BUTTON_AUTH = ['08000109', '08000110', '08000111', '08000112'];

export default {
    configuration: true,
    'buttonList': [
        {
            'type': 'text',
            'icon': 'el-icon-circle-check',
            'label': '启用',
            'size': 'small',
            'event': 'start',
            'ifHas': BUTTON_AUTH[0]
        },
        {
            'type': 'text',
            'icon': 'el-icon-circle-close',
            'label': '停用',
            'size': 'small',
            'event': 'stop',
            'ifHas': BUTTON_AUTH[1]
        },
        {
            'type': 'text',
            'icon': 'el-icon-refresh',
            'label': '同步',
            'size': 'small',
            'event': 'synchronize',
            'ifHas': BUTTON_AUTH[2]
        },
        {
            'type': 'text',
            'icon': 'el-icon-help',
            'label': '前往授权',
            'size': 'small',
            'event': 'authorize',
            'ifHas': BUTTON_AUTH[3]
        }
    ],
    'table': {
        'switchType': true,
        'tableCut': false,
        'clickState': false,
        'selectBtn': true,
        'height': 'calc(100vh - 215px)',
        'columns': [
            {
                'label': '盖章人姓名',
                'prop': 'stamperName',
                'width': '120px'
            },
            {
                'label': '盖章人身份证',
                'prop': 'stamperIdcard',
                'width': '180px'
            },
            {
                'label': '盖章人手机',
                'prop': 'stamperMobile',
                'width': '150px'
            },
            {
                'label': '盖章人邮箱',
                'prop': 'stamperEmail',
                'width': '150px'
            },
            {
                'label': '授权状态',
                'prop': 'stampStatusName',
                'width': '150px'
            },
            {
                'label': '盖章人状态',
                'prop': 'stamperTypeName',
                'width': '150px'
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    }
};